import { aadhaarLink } from './aadhaarLink'
import { addAgentUserIdentity } from './addAgentUserIdentity'
import { agentUserInformation } from './agentUserInformation'
import { appAuthApi } from './appAuthApi'
import { addNewBeneficiary } from './DomesticMoneyTransferMocks/addNewBeneficiary'
import { addNewCustomerDetails } from './DomesticMoneyTransferMocks/addNewCustomerDetails'
import { checkRemittanceStatus } from './DomesticMoneyTransferMocks/checkRemittanceStatus'
import { checkWhetherTheCustomerExists } from './DomesticMoneyTransferMocks/checkWhetherTheCustomerExists'
import { confirmFundTransfer } from './DomesticMoneyTransferMocks/confirmFundTransfer'
import { doesBeneficiaryAlreadyExist } from './DomesticMoneyTransferMocks/doesBeneficiaryAlreadyExist'
import { fetchKycDetails } from './DomesticMoneyTransferMocks/fetchKycDetails'
import { fetchRemittanceCustomerDetails } from './DomesticMoneyTransferMocks/fetchRemittanceCustomerDetails'
import { getAgentBankDetails } from './DomesticMoneyTransferMocks/getAgentBankDetails'
import { getBankNamesList } from './DomesticMoneyTransferMocks/getBankNamesList'
import { getBeneficiaryListApi } from './DomesticMoneyTransferMocks/getBeneficiaryListApi'
import { getConvenienceFeeApi } from './DomesticMoneyTransferMocks/getConvenienceFeeApi'
import { getDmrTransactions } from './DomesticMoneyTransferMocks/getDmrTransactions'
import { getDmtAvailableLimitApi } from './DomesticMoneyTransferMocks/getDmtAvailableLimitApi'
import { userAuthenticate } from './DomesticMoneyTransferMocks/userAuthenticate'
import { validateBeneficiaryCharges } from './DomesticMoneyTransferMocks/validateBeneficiaryCharges'
import { validateBeneficiaryWithAmountDeductionApi } from './DomesticMoneyTransferMocks/validateBeneficiaryWithAmountDeductionApi'
import { validateIfscCode } from './DomesticMoneyTransferMocks/validateIfscCode'
import { validateOtp } from './DomesticMoneyTransferMocks/validateOtp'
import { downloadReceipt } from './downloadReceipt'
import { eventLogging } from './event'
import { executeTransaction } from './executeTransaction'
import { fetchTransactionHistory } from './fetchTransactionHistory'
import { generateOtp } from './generateOtp'
import { getBankIfsc } from './getBankIfsc'
import { getBankIfscList } from './getBankIfscList'
import { getBankList } from './getBankList'
import { getConsentsMock } from './getConsents'
import { multiDeviceSession } from './multiDeviceSession'
import { getVoucher } from './refundApiMocks/getVoucher'
import { redeemVoucher } from './refundApiMocks/redeemVoucher'
import { resendVoucher } from './refundApiMocks/resendVoucher'

const mocks = {
  default: [
    ...getDmrTransactions.default,
    ...downloadReceipt.default,
    ...appAuthApi.default,
    ...agentUserInformation.default,
    ...getConsentsMock.default,
    ...generateOtp.default,
    ...executeTransaction.default,
    ...addAgentUserIdentity.default,
    ...getBankList.default,
    ...aadhaarLink.default,
    ...fetchTransactionHistory.default,
    ...addNewBeneficiary.default,
    ...addNewCustomerDetails.default,
    ...checkWhetherTheCustomerExists.default,
    ...fetchRemittanceCustomerDetails.default,
    ...getBeneficiaryListApi.default,
    ...getBankNamesList.default,
    ...userAuthenticate.default,
    ...validateIfscCode.default,
    ...validateOtp.default,
    ...checkRemittanceStatus.default,
    ...confirmFundTransfer.default,
    ...getConvenienceFeeApi.default,
    ...getAgentBankDetails.default,
    ...validateBeneficiaryCharges.default,
    ...validateBeneficiaryWithAmountDeductionApi.default,
    ...getVoucher.default,
    ...redeemVoucher.default,
    ...resendVoucher.default,
    ...doesBeneficiaryAlreadyExist.default,
    ...eventLogging.default,
    ...multiDeviceSession.default,
    ...multiDeviceSession.default,
    ...getBankIfscList.default,
    ...getBankIfsc.default,
    ...fetchKycDetails.default,
    ...getDmtAvailableLimitApi.default,
  ],
  failed: [
    ...getDmrTransactions.failed,
    ...downloadReceipt.failed,
    ...appAuthApi.failed,
    ...agentUserInformation.failed,
    ...getConsentsMock.failed,
    ...generateOtp.failed,
    ...executeTransaction.failed,
    ...addAgentUserIdentity.failed,
    ...getBankList.failed,
    ...aadhaarLink.failed,
    ...fetchTransactionHistory.failed,
    ...addNewBeneficiary.failed,
    ...addNewCustomerDetails.failed,
    ...checkWhetherTheCustomerExists.failed,
    ...fetchRemittanceCustomerDetails.failed,
    ...getBeneficiaryListApi.failed,
    ...getBankNamesList.failed,
    ...userAuthenticate.failed,
    ...validateIfscCode.failed,
    ...validateOtp.failed,
    ...checkRemittanceStatus.failed,
    ...confirmFundTransfer.failed,
    ...getConvenienceFeeApi.failed,
    ...getAgentBankDetails.failed,
    ...validateBeneficiaryCharges.failed,
    ...validateBeneficiaryWithAmountDeductionApi.failed,
    ...getVoucher.failed,
    ...redeemVoucher.failed,
    ...resendVoucher.failed,
    ...doesBeneficiaryAlreadyExist.failed,
    ...eventLogging.failed,
    ...multiDeviceSession.default,
    ...getBankIfscList.failed,
    ...getBankIfsc.failed,
    ...fetchKycDetails.failed,
    ...getDmtAvailableLimitApi.failed,
  ],
}

export { mocks }
